import PageReplacementModalRedux from './PageReplacementModalRedux';

export default PageReplacementModalRedux;